(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-new"] && !Shopify.designMode) return;
  try {
    
class AlHeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.al-hero__track');
    this.slides = Array.from(this.querySelectorAll('.al-hero__slide'));
    this.dots = Array.from(this.querySelectorAll('.al-hero__dot'));
    this.prevBtn = this.querySelector('.al-hero__arrow--prev');
    this.nextBtn = this.querySelector('.al-hero__arrow--next');
    this.current = 0;
    this.timer = null;

    if (this.slides.length <= 1) return;

    this.updateTrackRatio();

    this.prevBtn?.addEventListener('click', () => this.go(this.current - 1));
    this.nextBtn?.addEventListener('click', () => this.go(this.current + 1));
    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.go(i));
    });

    if (this.dataset.autoplay === 'true') {
      const speed = Number(this.dataset.autoplaySpeed) || 5000;
      this.startAutoplay(speed);
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay(speed));
    }
  }

  go(index) {
    const total = this.slides.length;
    this.current = (index + total) % total;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('al-hero__slide--active', i === this.current);
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('al-hero__dot--active', i === this.current);
    });

    this.updateTrackRatio();
  }

  updateTrackRatio() {
    const activeSlide = this.slides[this.current];
    if (!activeSlide || !this.track) return;
    this.track.style.setProperty('--al-slide-desktop-ratio', activeSlide.dataset.desktopRatio);
    this.track.style.setProperty('--al-slide-mobile-ratio', activeSlide.dataset.mobileRatio);
  }

  startAutoplay(speed) {
    this.stopAutoplay();
    this.timer = setInterval(() => this.go(this.current + 1), speed);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }
}

if (!customElements.get('al-hero-slideshow')) {
  customElements.define('al-hero-slideshow', AlHeroSlideshow);
}

  } catch(e) { console.error(e); }
})();
})();
